export default {
  humanTraining_introduction: '介绍',
  humanTraining_catalog: '目录({resourcesCount})',
  humanTraining_leran_rules: '完成规则',
  humanTraining_training_no_start: '培训项目暂未开始!',
  humanTraining_course_duration: '课程学时',
  humanTraining_duration: '学时',
  humanTraining_have_duration: '已获得学时',
  humanTraining_valid_duration: '未获得',
  humanTraining_resource_duration: '资源学时：',
  humanTraining_own_duration: '已获得学时：',
  humanTraining_book_title_mark1: '《',
  humanTraining_book_title_mark2: '》',
  humanTraining_examScore: '考试成绩 {examScore}分/{totalScore}分',
  humanTraining_endDays: '距离考试截止 {endDays}天',
  humanTraining_end_todays: '考试截止今天结束',
  humanTraining_test_num: '共{testNum}题',
  humanTraining_service_error: '服务错误！',
  humanTraining_live_status: '培训项目暂不支持观看回放',
  humanTraining_total_period: '完成',
  humanTraining_online_period: '完成线上',
  humanTraining_offline_period: '完成线下',
  humanTraining_go_learn: '去学习',
  humanTraining_no_rules: '还没有规则',
  humanTraining_exam_tasks: '考试任务',
  humanTraining_past: '通过{examName}',
  humanTraining_residualExamNum: '分通过（共{residualExamNum}次机会）',
  humanTraining_examination: '考取',
  humanTraining_max_score: "分（{examCountNum}次机会）",
  humanTraining_exam_again: '重新考试',
  humanTraining_go_exam: '去考试',
  humanTraining_no_brief_intro:"暂无简介",
  humanTraining_empty_training_program:'还没有培训项目',
  humanTraining_training_program_end:'培训项目已结束!',
  humanTraining_training_duration:'培训学时',
  humanTraining_total_time:'共{periodTotal}个学时',
  humanTraining_total:'共',
  humanTraining_sheng:'剩'
}
